import { get } from 'lodash';

export const getTrialPlacementOptions = (state) => {
  return get(state, 'trialPlacementOptions');
};
